var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSocialNav(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1090_12501)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 5.5,
    r: 2.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.37305 11.8558C3.86717 12.4739 4.37004 13.2483 4.63364 13.7183C4.95501 14.328 5.08671 14.7398 5.3258 15.4732C5.46586 15.8769 5.59757 16.0004 5.87694 16.0004C6.18101 16.0004 6.32184 15.7944 6.42903 15.4732C6.65138 14.7811 6.82452 14.2539 7.09629 13.7512C7.63184 12.7873 8.30747 11.9303 8.96656 11.1065C9.14786 10.8758 10.3013 9.51635 10.8203 8.43706C10.8203 8.43706 11.4547 7.25876 11.4547 5.61123C11.4547 4.0705 10.8275 2.99939 10.8275 2.99939L9.01502 3.48553L7.91103 6.38567L7.63907 6.78117L7.58205 6.85529L7.50793 6.94594L7.3844 7.09418L7.2031 7.27548L6.22264 8.07369L3.77671 9.49202L3.37305 11.8558Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.84375 8.23905C1.44525 9.60739 2.59049 10.8013 3.37311 11.8559L7.51731 6.94538C7.51731 6.94538 6.93272 7.71166 5.87776 7.71166C4.69946 7.71166 3.74389 6.77244 3.74389 5.58616C3.74389 4.77047 4.23004 4.21021 4.23004 4.21021L1.42131 4.95995L0.84375 8.23905Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.56666 0.255615C8.94261 0.700519 10.1207 1.63157 10.8292 3.00733L7.51725 6.95369C7.51725 6.95369 8.0034 6.38525 8.0034 5.57774C8.0034 4.36656 6.98169 3.45204 5.8777 3.45204C4.83129 3.45204 4.22998 4.21015 4.22998 4.21015V1.72203L7.56666 0.255615Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.60156 1.9938C2.42542 1.01334 3.86713 0 5.86093 0C6.82505 0 7.55825 0.255425 7.55825 0.255425L4.22974 4.21015H1.87314L1.60156 1.9938Z",
    fill: "#1A73E8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.843534 8.23902C0.843534 8.23902 0.299805 7.15974 0.299805 5.60248C0.299805 4.1277 0.876602 2.8424 1.60981 2.0022L4.23799 4.21835L0.843534 8.23902Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1090_12501"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.1555,
    height: 16,
    fill: "white",
    transform: "translate(0.299805)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialNav);
export default __webpack_public_path__ + "static/media/social_nav.876be27cd8911abc4a2d261edb8df78b.svg";
export { ForwardRef as ReactComponent };